import { useState } from "react";

const categories = [
  { id: "tickets", title: "Tickets", subtitle: "General admission" },
  { id: "memberships", title: "Memberships", subtitle: "Annual Passes" },
  { id: "experiences", title: "In-park Experiences", subtitle: "Add-ons" },
];

const options = [
  { id: "promo", label: "Promo" },
  { id: "single", label: "Single Park" },
  { id: "multi", label: "Multi Park" },
];

export default function TicketSelection() {
  const [selectedCategory, setSelectedCategory] = useState("tickets");
  const [selectedOption, setSelectedOption] = useState("promo");

  return (
    <div className="flex bg-[#f9f5eb] font-georgia flex-col items-center justify-center w-full p-4 sm:p-6 bg-cream">
      
      <h2 className="mt-4 mb-10 text-3xl font-bold text-center text-green-900 sm:text-5xl">What are you looking for?</h2>
      
      <div className="flex justify-center w-full max-w-lg gap-4 pb-4 mb-4 border-green-900">
        {categories.map((category,index) => (
          <div key={category.id} className={`w-1/3 ${index ===1&&"border-r border-green-900 px-4 border-l"} text-center cursor-pointer sm:w-auto`}
               onClick={() => setSelectedCategory(category.id)}> 
            <h3 className={`text-sm sm:text-lg font-semibold ${selectedCategory === category.id ? 'text-green-900' : 'text-gray-500'}`}>{category.title}</h3>
            <p className="text-xs text-gray-500 sm:text-sm">{category.subtitle}</p>
            {selectedCategory === category.id && <div className="w-full h-1 mt-1 bg-green-900"></div>}
          </div>
        ))}
      </div>
      
      <div className="flex flex-wrap justify-center w-full max-w-xs overflow-hidden border border-green-900 rounded-full sm:max-w-xl">
        {options.map((option, index) => (
          <button key={option.id} 
                  className={`flex-1 px-4 py-2 sm:px-6 sm:py-3 font-semibold text-sm sm:text-xl ${index ===1&&"border-r border-green-900 px-4  "} ${selectedOption === option.id ? 'bg-[#202721] text-white' : 'bg-white text-green-900'}`} 
                  onClick={() => setSelectedOption(option.id)}>
            {option.label}
          </button>
        ))}
      </div>
    </div>
  );
}
